/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './adr-table.scss';

/* eslint-disable import/no-unresolved, import/default */

import adrTableTemplate from './adr-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.AdrTable', [])
    .directive('tkNetworkSettingsAdrTable', NetworkSettingsAdrTable)
    .name;

/*@ngInject*/
function NetworkSettingsAdrTable($compile, $templateCache, types) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(adrTableTemplate);
        element.html(template);

        scope.COLLAPSED_ROWS_COUNT = 3;
        scope.isCollapsed = false;

        scope.data_rates = angular.copy(types.data_rate).slice(0, -1);

        scope.editRangeIndex = null;
        scope.beforeEditRow = null;

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
                scope.adrNbTransRanges = [];
                for (var [key, value] of Object.entries(ngModelCtrl.$viewValue)) {
                    var el = {
                        "dr": Number(key),
                        "minNbTrans": value.minNbTrans,
                        "maxNbTrans": value.maxNbTrans
                    }
                    scope.adrNbTransRanges.push(el);
                }
            }
        };

        scope.$watch('adrNbTransRanges', function (newVal) {
            if (newVal && scope.editRangeIndex !== null) {
                updateValidity(scope.editRangeIndex);
            }
        }, true);

        scope.$watch('editRangeIndex', function(newVal) {
            scope.$emit('activeChanges', newVal !== null);
        })

        scope.editAdrRange = (index) => {
            if (scope.editRangeIndex !== null) {
                scope.cancelAdrRange(scope.editRangeIndex);
            }
            scope.editRangeIndex = index;
            scope.beforeEditRow = angular.copy(scope.adrNbTransRanges[index]);
            updateUsedDR();
        }

        scope.isEditRow = (index) => index === scope.editRangeIndex;

        function updateUsedDR() {
            let allUsedDR = scope.adrNbTransRanges.map(a => a.dr);
            scope.usedDR = allUsedDR.filter(item => item !== scope.adrNbTransRanges[scope.editRangeIndex].dr)
        }

        scope.toggleCollapsed = () => {
            scope.isCollapsed = !scope.isCollapsed;
        }

        scope.addAdrRange = () => {
            scope.isCollapsed = false;
            if (scope.editRangeIndex !== null) {
                scope.cancelAdrRange(scope.editRangeIndex);
            }
            scope.adrNbTransRanges.push({ "dr": null, "minNbTrans": null, "maxNbTrans": null });
            scope.beforeEditRow = null;
            scope.editRangeIndex = scope.adrNbTransRanges.length - 1;
            updateUsedDR();
        }

        scope.saveAdrRange = () => {
            if (scope.theForm.adrRangesForm.$valid) {
                updateValue();
                scope.editRangeIndex = null;
            }
        }

        scope.cancelAdrRange = (index) => {
            if (scope.beforeEditRow) {
                scope.adrNbTransRanges[index] = angular.copy(scope.beforeEditRow);
            } else {
                scope.adrNbTransRanges.splice(index, 1);
            }
            scope.editRangeIndex = null;
        }

        scope.deleteAdrRange = (index) => {
            if (scope.editRangeIndex !== null) {
                scope.cancelAdrRange(scope.editRangeIndex);
            }
            scope.adrNbTransRanges.splice(index, 1);
            updateValue();
        }

        function updateValidity(index) {
            var el = scope.adrNbTransRanges[index];
            if (el.minNbTrans && el.maxNbTrans) {
                scope.theForm.adrRangesForm.max.$setValidity('minMax', el.minNbTrans <= el.maxNbTrans);
            }
        }

        function updateValue() {
            var value = {};
            scope.adrNbTransRanges.forEach(function (range) {
                value[range.dr.toString()] = {
                    "minNbTrans": range.minNbTrans,
                    "maxNbTrans": range.maxNbTrans
                }
            });
            ngModelCtrl.$setViewValue(value);
        }

        $compile(element.contents())(scope);
    }

    return {
        restrict: "E",
        require: "^ngModel",
        link: linker
    };
}


// WEBPACK FOOTER //
// ./src/app/network-settings/adr-table/adr-table.directive.js